import { useViewTableData, skeletonFactory, useRequestLoading } from 'shared';
import { orders as ordersService } from 'services';
import { useCallback } from 'react';

const ordersDummy = skeletonFactory.orders();

export function useOrdersPaginated() {
  const {
    data: orders,
    get: getOrders,
    exportElements: exportOrders
  } = useViewTableData({
    service: ordersService,
    paginatedSkeleton: ordersDummy
  });
  const { requestLoading, callbackRequest } = useRequestLoading();

  const exportItems = useCallback(
    async (headCells, fileName = 'orders') => {
      await callbackRequest(async () => {
        return exportOrders(headCells, fileName);
      });
    },
    [exportOrders, callbackRequest]
  );

  return {
    orders,
    getOrders,
    exportItems,
    isExporting: requestLoading
  };
}
